import {
  DeliveryMethod,
  type SelectedAppointment,
} from '@service-initiation/tech-care-data-access-store';

export const validateSelectedAppointment = (
  selectedAppointment?: SelectedAppointment
): boolean => {
  return !!(
    selectedAppointment?.date &&
    selectedAppointment.startTime &&
    selectedAppointment.endTime
  );
};

export const completedAppointmentTime = async (
  appointment: SelectedAppointment,
  deliveryMethod: DeliveryMethod
) => {
  const validAppt = validateSelectedAppointment(appointment);
  return deliveryMethod === DeliveryMethod.MailIn || validAppt;
};
